define([
	"dojo/_base/declare",
	"csi/comm/Aspera",
	"csi/table/NewWithUpload",
	"./ContractualDocumentFormActionMixin"
], function(declare,Aspera,NewWithUpload,ContractualDocumentFormActionMixin) {

	const SOURCE_FILE = "SourceFile";

	return declare([NewWithUpload, ContractualDocumentFormActionMixin], {

		toWriterFields: function(/*String*/urlNode, /*FormData?*/fd) {
			this._adjustSaveScript(urlNode, fd);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Publish request to create new contractual document
		 */
		process: function() {
			if (Aspera.isEnabled() && this.popupView.uploadAsperaFile){
				const self = this;
				this.disableActionView(true);
				this.m_urlNode = this.createNewUrl();
				Aspera.uploadContractualFile(this.m_urlNode, this.popupView.asperaData, this).then(
					function(response){
						const w = self.m_writer;
						if (self.bUseResultNodeUrl) {
							const node = response.getResultNode();
							if (node) {
								self.m_urlNode = node.$URL;
							}
						}

						if (self.m_urlNode) {
							self.getActionView().m_defView.getFormData().getFieldValue(SOURCE_FILE, true);
							self.toWriterFields(self.m_urlNode);
						}

						self._onPublishResponse(response);
					},
					function(msg){
						self.m_error = msg || ""; // do not show error if user cancels file selection
						self.postProcess(false);
					}
				);
				return;
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Enable Action View in case of server side validation error
		 */
		postProcess: function(){
			this.inherited(arguments);
			if (Aspera.isEnabled()){
				this.disableActionView(false);
			}
		},

		/**
		 * @override
		 * Clear Aspera data on save to handle Save & New case
		 */
		postProcessSuccess: function(){
			this.inherited(arguments);
			if (Aspera.isEnabled()){
				this.popupView.asperaData = null;
			}
		}
	});
});